import React, {useContext, useEffect, useCallback, useState} from 'react';
import {Button, setOptions, confirm} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faBars,
    faPipe,
    faPlus,
    faBell,
    faMessages,
    faTrashCan,
    faFloppyDisk,
    faArrowRightFromArc
} from "@fortawesome/pro-duotone-svg-icons";
import '../styles/dashboardHeader.css';
import DashboardHeaderUser from "../dialogs/DashboardHeaderUser";
import DashboardHeaderAccount from "../dialogs/DashboardHeaderAccount";
import DashboardHeaderConversations from "../dialogs/DashboardHeaderConversations";
import DashboardHeaderOperations from "../dialogs/DashboardHeaderOperations";
import DashboardHeaderMenu from "../dialogs/DashboardHeaderMenu";
import DashboardHeaderNotifications from "../dialogs/DashboardHeaderNotifications";
import DashboardHeaderConversationDuplicate from "../dialogs/DashboardHeaderConversationDuplicate";
import DashboardHeaderConversationRename from "../dialogs/DashboardHeaderConversationRename";
import DashboardHeaderConversationNew from "../dialogs/DashboardHeaderConversationNew";
import DashboardHeaderReset from "../dialogs/DashboardHeaderReset";
import DashboardHeaderMobile from "../dialogs/DashboardHeaderMobile";
import DashboardHeaderAccountUser from "../dialogs/DashboardHeaderAccountUser";
import DashboardHeaderInvite from "../dialogs/DashboardHeaderInvite";
import DashboardHeaderPatients from "../dialogs/DashboardHeaderPatients";
import DashboardHeaderQuestion from "../dialogs/DashboardHeaderQuestion";
import Empty from "../utils/Empty";
import Truncate from "../utils/Truncate";
import {NetworkContext} from "../utils/NetworkContext";


setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeader({Navigation, navigation, wss, width, locale, dialog, Dialog, configuration, user, Conversation, functions, toast, system, setLocale, setUser, token, setToast, setMessages, setText, setWorkspace, setStack, teamtalk, setTeamtalk, notifications, setNotifications, account, setTokensUsed, setFolded, sort, label, setLabel}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [archive, setArchive] = useState({});
    const [userData, setUserData] = useState({});
    const [quickQuestion, setQuickQuestion] = useState({});
    const [iconHover, setIconHover] = useState(null);

    const Logout = useCallback(data => {
        const message = {
            type: 'wss',
            path: 'user-logout',
            action: 'update',
            data: data && data === 'all' ? {all: true} : {}
        };
        wsCall(message);
    }, [wsCall]);

    const Notifications = () => {
        const array = notifications.filter(item => !item.opened);

        return array.length;
    };

    const ButtonTab = data => {
        Dialog({view: 'dashboardHeaderConversationNew', tab: 'conversation'});
    };

    const ButtonDisabled = data => {
        let item = false;
        if (!Empty(toast) || system || (data && navigation.card === data)) {
            item = true;
        }
        return item;
    };

    const ButtonDelete = () => {
        const text = locale.dashboardHeader.l + " '" + label + "'" + locale.dashboardHeader.x;
        const title = locale.dashboardHeader.d + " '" + label + "'";

        confirm({
            title: title,
            message: text,
            okText: locale.dashboardHeader.d,
            cancelText: locale.dashboardHeader.n,
            callback: (res) => {
                if (res) {
                    setToast({message: locale.dashboardHeader.o, color: 'info', display: 'bottom', duration: 1000});

                    const message = {
                        type: 'wss',
                        path: 'tab',
                        action: 'delete',
                        data: {}
                    };
                    wsCall(message);
                }
            }
        });
    }

    const ButtonLeave = () => {
        if (!Empty(teamtalk) && teamtalk.users && teamtalk.users.length === 1) {
            confirm({
                title: locale.dashboardHeader.q,
                message: locale.dashboardHeader.s,
                okText: locale.dashboardHeader.d,
                cancelText: locale.dashboardHeader.n,
                callback: (res) => {
                    if (res) {

                        const message = {
                            type: 'wss',
                            path: 'teamtalk-conversation',
                            action: 'delete',
                            data: {
                                teamtalk: {id: teamtalk.id, users: teamtalk.users}
                            }
                        };
                        wsCall(message);
                    }
                }
            });
        } else {
            confirm({
                title: locale.dashboardHeader.r,
                message: locale.dashboardHeader.t,
                okText: locale.dashboardHeader.p,
                cancelText: locale.dashboardHeader.n,
                callback: (res) => {
                    if (res) {

                        const message = {
                            type: 'wss',
                            path: 'teamtalk-conversation-user',
                            action: 'delete',
                            data: {
                                teamtalk: {id: teamtalk.id, users: teamtalk.users}
                            }
                        };
                        wsCall(message);
                    }
                }
            });
        }
    }

    const UpdateUserLogout = useCallback(data => {
        if (data.toast) {
            setToast({message: locale.dashboardHeader.f, color: 'info', display: 'bottom', duration: 3000});
            window.localStorage.removeItem('token');
            window.localStorage.text = '<p></p>';
            token.current = '';
            wss.current = '';
            setUser({});
            Navigation({view: 'login'});
        }
    }, [Navigation, locale.dashboardHeader.f]);

    const UpdateUser = useCallback(data => {
        if (data.toast) {
            setToast({message: locale.dashboardHeader.j, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.user) {
            setUser(data.user);
        }
        if (dialog.view) {
            Dialog({view: 'close'});
        }
    }, [locale.dashboardHeader.j, Dialog, dialog.view]);

    const DeleteTeamtalkConversation = useCallback(data => {
        if (data.toast) {
            setTeamtalk({});
            setToast({message: locale.dashboardHeader.v, color: 'info', display: 'bottom', duration: 1000});

            Conversation();
        }
    }, [Conversation, locale.dashboardHeader.v]);

    const DeleteTeamtalkConversationUser = useCallback(data => {
        if (data.conversation) {
            setTeamtalk({});
            setToast({message: locale.dashboardHeader.u, color: 'info', display: 'bottom', duration: 1000});
            Conversation();
        }
        if (data.teamtalkUsers) {
            const item = {...teamtalk};
            item.users = data.teamtalkUsers;
            setTeamtalk(item);
            setToast({message: locale.dashboardHeader.w, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [teamtalk, Conversation, locale.dashboardHeader.u, locale.dashboardHeader.w]);

    useEffect(() => {
        if (wsResponse &&
            !Empty(wsResponse) &&
            wsResponse.action === 'delete' &&
            wsResponse.path === 'teamtalk-conversation-user' &&
            !Empty(teamtalk) &&
            wsResponse.data.teamtalk &&
            teamtalk.id === wsResponse.data.teamtalk) {
            DeleteTeamtalkConversationUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteTeamtalkConversationUser, setWsResponse, teamtalk]);

    useEffect(() => {
        if (wsResponse &&
            !Empty(wsResponse) &&
            wsResponse.action === 'delete' &&
            wsResponse.path === 'teamtalk-conversation' &&
            !Empty(teamtalk) &&
            wsResponse.data.teamtalk &&
            teamtalk.id === wsResponse.data.teamtalk) {
            DeleteTeamtalkConversation(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteTeamtalkConversation, setWsResponse, teamtalk]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'user') {
            UpdateUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateUser, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'user-logout') {
            UpdateUserLogout(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateUserLogout, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.data.expired) {
            Logout(null);
            setWsResponse({});
        }
    }, [wsResponse, setWsResponse, Logout]);

    return (
        <div className="mbsc-grid cs-dashboard-header-toolbar" >
            <div className="mbsc-row">
                <div className="mbsc-col" >
                    <div className={width < 1200 ? "mbsc-row cs-dashboard-header-col-start-s" : "mbsc-row cs-dashboard-header-col-start"}>
                        {width > 1200 &&
                            <div style={configuration.logo ? {backgroundImage: `url(${configuration.logo})`} : {backgroundImage: `url(${configuration.logoCS})`}} className={(width < 992 && !configuration.teamtalk) ? "cs-dashboard-header-logo-xs" : "cs-dashboard-header-logo"}  />
                        }
                        {width > 768 &&
                            <Button color="primary" variant="flat" className="cs-dashboard-header-color cs-dashboard-header-cursor mbsc-bold" >
                                {width > 992 ? Truncate((label), 30) : Truncate((label), 15)}
                            </Button>
                        }
                    </div>
                </div>
                <div className="mbsc-col-auto" >
                    <div className="mbsc-row cs-dashboard-header-col-end">
                        {configuration.billingStatus === 'active' && width > 576 && Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('plus')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color" title={locale.dashboardHeader.b} onClick={() => ButtonTab()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPlus} beatFade={iconHover === 'plus'} /><div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.b}</div>
                            </Button>
                        }
                        {configuration.billingStatus === 'active' && width > 576 &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        {configuration.billingStatus === 'active' && width > 576 && Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('save')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color" title={locale.dashboardHeader.g} onClick={() => Dialog({view: 'dashboardQuestionSave'})} >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faFloppyDisk} beatFade={iconHover === 'save'} />{width > 992 && <div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.g}</div>}
                            </Button>
                        }
                        {configuration.billingStatus === 'active' && width > 576 && Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('delete')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color" title={locale.dashboardHeader.d} onClick={() => ButtonDelete()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faTrashCan} beatFade={iconHover === 'delete'} />{width > 992 && <div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.d}</div>}
                            </Button>
                        }
                        {configuration.billingStatus === 'active' && width > 576 && !Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('leave')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color" title={locale.dashboardHeader.p} onClick={() => ButtonLeave()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faArrowRightFromArc} beatFade={iconHover === 'leave'} /><div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.p}</div>
                            </Button>
                        }
                        {configuration.billingStatus === 'active' && width > 576 &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        {configuration.billingStatus === 'active' &&
                            <Button onMouseEnter={() => setIconHover('conversations')} onMouseLeave={() => setIconHover(null)} disabled={system} color="primary" variant="flat" className={width < 576 ? "mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" : "mbsc-bold cs-dashboard-header-color"} title={locale.dashboardHeader.i} onClick={() => Dialog({view: 'dashboardHeaderConversations'})} >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faMessages} beatFade={iconHover === 'conversations'} /><div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.i}</div>
                            </Button>
                        }
                        {configuration.billingStatus === 'active' &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        {notifications.length !== 0 &&
                            <Button onMouseEnter={() => setIconHover('bell')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className={width < 576 ? "mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" : "mbsc-bold cs-dashboard-header-color"} id="dashboardHeaderNotifications" title={locale.dashboardHeader.a} onClick={() => Dialog({view: 'dashboardHeaderNotifications'})}>
                                <div className="cs-dashboard-header-badge">
                                    <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faBell} shake={iconHover === 'bell'} />
                                    {notifications.some(item => !item.opened) &&
                                        <span className="cs-dashboard-header-badge-icon">{Notifications()}</span>
                                    }
                                </div>
                            </Button>
                        }
                        {notifications.length !== 0 &&
                            <Button color="secondary" variant="flat" className="cs-dashboard-header-cursor" >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPipe} />
                            </Button>
                        }
                        <Button onMouseEnter={() => setIconHover('menu')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color" id="dashboardHeaderMenu" title={locale.dashboardHeader.e} onClick={() => Dialog({view: 'dashboardHeaderMenu'})} >
                            {width > 992 && '\u00A0'}<FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faBars} fade={iconHover === 'menu'} />
                        </Button>
                    </div>
                </div>
            </div>
            {configuration.billingStatus === 'active' && width < 576 && configuration.billingStatus === 'active' &&
                <div className="mbsc-row cs-dashboard-header-nav mbsc-align-right" >
                    <div className="mbsc-col" >
                        {Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('plus')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" title={locale.dashboardHeader.b} onClick={() => ButtonTab()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faPlus} beatFade={iconHover === 'plus'} /><div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.b}</div>
                            </Button>
                        }
                        {Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('save')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" title={locale.dashboardHeader.g} onClick={() => Dialog({view: 'dashboardQuestionSave'})} >
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faFloppyDisk} beatFade={iconHover === 'save'} />
                            </Button>
                        }
                        {Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('delete')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" title={locale.dashboardHeader.d} onClick={() => ButtonDelete()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faTrashCan} beatFade={iconHover === 'delete'} />
                            </Button>
                        }
                        {!Empty(teamtalk) &&
                            <Button onMouseEnter={() => setIconHover('leave')} onMouseLeave={() => setIconHover(null)} disabled={ButtonDisabled()} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-color cs-dashboard-header-button-tabs" title={locale.dashboardHeader.p} onClick={() => ButtonLeave()}>
                                <FontAwesomeIcon className="cs-dashboard-header-button-icon" icon={faArrowRightFromArc} beatFade={iconHover === 'leave'} /><div className="cs-dashboard-header-menu-text">{locale.dashboardHeader.p}</div>
                            </Button>
                        }
                    </div>
                </div>
            }
            {dialog.view === 'dashboardHeaderQuestion' &&
                <DashboardHeaderQuestion
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                    setToast={setToast}
                    toast={toast}
                    quickQuestion={quickQuestion}
                    setQuickQuestion={setQuickQuestion}
                />
            }
            {dialog.view === 'dashboardHeaderUser' &&
                <DashboardHeaderUser
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    user={user}
                    Logout={Logout}
                    setUser={setUser}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderConversationRename' &&
                <DashboardHeaderConversationRename
                    Dialog={Dialog}
                    dialog={dialog}
                    locale={locale}
                    width={width}
                    archive={archive}
                    setArchive={setArchive}
                />
            }
            {dialog.view === 'dashboardHeaderConversationDuplicate' &&
                <DashboardHeaderConversationDuplicate
                    Dialog={Dialog}
                    dialog={dialog}
                    locale={locale}
                    width={width}
                    archive={archive}
                    setArchive={setArchive}
                />
            }
            {dialog.view === 'dashboardHeaderConversations' &&
                <DashboardHeaderConversations
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                    navigation={navigation}
                    configuration={configuration}
                    locale={locale}
                    setTeamtalk={setTeamtalk}
                    setQuickQuestion={setQuickQuestion}
                    setArchive={setArchive}
                    setToast={setToast}
                    teamtalk={teamtalk}
                />
            }
            {dialog.view === 'dashboardHeaderOperations' &&
                <DashboardHeaderOperations
                    dialog={dialog}
                    Dialog={Dialog}
                    locale={locale}
                    teamtalk={teamtalk}
                    Navigation={Navigation}
                    width={width}
                    navigation={navigation}
                    configuration={configuration}
                />
            }
            {dialog.view === 'dashboardHeaderMenu' &&
                <DashboardHeaderMenu
                    dialog={dialog}
                    Dialog={Dialog}
                    locale={locale}
                    Logout={Logout}
                    user={user}
                    configuration={configuration}
                    setLocale={setLocale}
                    setUser={setUser}
                    setToast={setToast}
                    Navigation={Navigation}
                    toast={toast}
                    system={system}
                    navigation={navigation}
                    functions={functions}
                    account={account}
                />
            }
            {dialog.view === 'dashboardHeaderNotifications' &&
                <DashboardHeaderNotifications
                    dialog={dialog}
                    Dialog={Dialog}
                    notifications={notifications}
                    setNotifications={setNotifications}
                />
            }
            {dialog.view === 'dashboardHeaderConversationNew' &&
                <DashboardHeaderConversationNew
                    Dialog={Dialog}
                    dialog={dialog}
                    locale={locale}
                    setMessages={setMessages}
                    setText={setText}
                    Navigation={Navigation}
                    width={width}
                    setWorkspace={setWorkspace}
                    setTeamtalk={setTeamtalk}
                    setStack={setStack}
                    configuration={configuration}
                    archive={archive}
                    setArchive={setArchive}
                    Conversation={Conversation}
                    setTokensUsed={setTokensUsed}
                    setFolded={setFolded}
                    label={label}
                    setLabel={setLabel}
                />
            }
            {dialog.view === 'dashboardHeaderReset' &&
                <DashboardHeaderReset
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderMobile' &&
                <DashboardHeaderMobile
                    Dialog={Dialog}
                    dialog={dialog}
                    locale={locale}
                    configuration={configuration}
                    width={width}
                    toast={toast}
                />
            }
            {dialog.view === 'dashboardHeaderAccountUser' &&
                <DashboardHeaderAccountUser
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    userData={userData}
                    width={width}
                    configuration={configuration}
                />
            }
            {dialog.view === 'dashboardHeaderAccount' &&
                <DashboardHeaderAccount
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                    setUserData={setUserData}
                    configuration={configuration}
                />
            }
            {dialog.view === 'dashboardHeaderInvite' &&
                <DashboardHeaderInvite
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                />
            }
            {dialog.view === 'dashboardHeaderPatients' &&
                <DashboardHeaderPatients
                    locale={locale}
                    dialog={dialog}
                    Dialog={Dialog}
                    width={width}
                    teamtalk={teamtalk}
                    navigation={navigation}
                    Navigation={Navigation}
                    setWorkspace={setWorkspace}
                    setStack={setStack}
                    sort={sort}
                />
            }
        </div>
    );
}

export default DashboardHeader;
